<template src="./unauthorizedUser.html"></template>

<script>
// Third party Imports
import axios from 'axios';
import generator from 'generate-password';

// Components Imports
import MagicVueInput from '../MagicInput.vue';

// Services Imports
import { eventService } from '@/services';

// Router Imports
import router from '@/router';

import { mapActions } from 'vuex';

// Scss Imports
import './unauthorizedUser.scss';
import { computed } from '@vue/composition-api';

export default {
  name: 'unauthorizeduser',
  components: {
    MagicVueInput,
  },
  props: ['additional'],
  data() {
    return {
      file: null,
      name: '',
      type: '',
      email: '',
      vemail: '',
      vphone: '',
      password: '',
      username: '',
      submittedOnce: false,
      showRegister: false,
      disableButton: false,
      loadStyle: {
        color: '#ffffff',
        'font-weight': 'bold',
        'letter-spacing': '1rem',
        'font-size': '18px',
      },
    };
  },
  computed: {
    phoneValidate() {
      const tmp = this.vphone
        .split('-')
        .join('')
        .split(' ')
        .join('')
        .split('+')
        .join('')
        .split('(')
        .join('')
        .split(')')
        .join('');
      return tmp;
    },
  },
  methods: {
    ...mapActions('account', ['register', 'registerUsers']),
    closepopup() {
      this.$emit('closepopup', false);
    },
    close() {
      this.$emit('closeModel', false);
    },
    generatePassword() {
      let securedPassword = false;
      while (!securedPassword) {
        const password = generator.generate({
          length: 12,
          numbers: true,
          lowercase: true,
          uppercase: true,
          symbols: true,
          strict: true,
        });

        securedPassword = true;
        this.password = password;
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    phonechanged(event) {
      let newValue = event;
      if (event.startsWith('+') && !newValue.startsWith('+1 (')) {
        newValue = newValue.slice(1);
      }
      let updatedValue = '';
      const match = newValue.match(/^[0-9+]/g);
      if (!match) {
        updatedValue = newValue.slice(0, -1);
        return updatedValue;
      }
      if (newValue.startsWith('+1 (')) {
        newValue = newValue.slice(4, newValue.length);
      }
      if (newValue.length >= 1 && !isNaN(parseInt(newValue[0]))) {
        var x = newValue
          .replace(/\D/g, '')
          .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        updatedValue = !x[2]
          ? x[1]
          : '+1 (' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      } else {
        updatedValue = newValue;
      }

      this.vphone = updatedValue;
      return updatedValue;
    },
    redirectToLogin() {
      this.showRegister = false;
      localStorage.setItem('recentLink', this.$route.path);
      router.push('/login');
    },
    formDataToSubmit() {
      const form = new FormData();

      form.append('username', '');
      form.append('fullName', this.name.trim());
      form.append('email', this.email);
      form.append('phoneNumber', this.vphone);
      form.append('password', '');
      form.append('zipcode', '');
      form.append('userRole', 'MYLER');
      form.append('comunityMember', 'Not Affiliated with Partner');
      form.append('latitude', '0');
      form.append('longitude', '0');
      form.append('isSocial', '0');
      form.append('emailVerified', 0);
      form.append('facebook', '');
      form.append('google', '');
      form.append('linkedIn', '');
      form.append('twitter', '');
      form.append('website', '');
      form.append('aboutMe', '');
      form.append('presenter', '');
      form.append('profilePicture', this.file, this.file.name);
      form.append('instantSignup', '1');

      return form;
    },
    async registerUser() {
      this.submittedOnce = true;

      if (
        !this.validateEmail(this.email) ||
        this.name.trim().length <= 0 ||
        this.email !== this.vemail ||
        (this.phoneValidate.length !== 11 && this.phoneValidate.length !== 0)
      ) {
        this.$toast.error('Please provide complete information', {
          timeout: 4000,
        });
        return;
      }

      localStorage.setItem('recentregLink', this.$route.path);

      try {
        this.disableButton = true;
        const res = await this.register({
          data: this.formDataToSubmit(),
          password: this.password,
        });
        if (res && res.error) {
          this.$toast.error(res.message, { timeout: 4000 });
          this.disableButton = false;
        } else {
          this.close();
        }
        this.disableButton = false;
      } catch (e) {
        this.$toast.error('Registeration Failed', { timeout: 4000 });
        this.disableButton = false;
        this.$emit('setLoader', false);
      }
    },
    cancel() {
      this.close();
    },
    async registerUserdata() {
      this.submittedOnce = true;
      this.$emit('setLoader', true);

      if (!this.validateEmail(this.email) || this.name.trim().length <= 0) {
        this.$toast.error('Please provide complete information', {
          timeout: 4000,
        });
        this.$emit('setLoader', false);
        return;
      }

      try {
        this.disableButton = true;
        const res = await this.registerUsers({
          data: this.formDataToSubmit(),
          password: this.password,
        });
        if (res && res.error) {
          this.$toast.error(res.message, { timeout: 4000 });
          this.disableButton = false;
        } else {
          this.$emit('setLoader', false);
          this.$emit('checkout', res);
        }
        this.$emit('setLoader', false);
        this.disableButton = false;
      } catch (e) {
        this.$toast.error('Registeration Failed', { timeout: 4000 });
        this.disableButton = false;
        this.$emit('setLoader', false);
      }
    },
  },
  async mounted() {
    const response = await axios.get('/img/myle/svg/logo.svg', {
      responseType: 'blob',
    });

    const file = new File([response.data], 'presenterProfilePicture', {
      type: response.data.type,
    });
    this.file = file;
  },
};
</script>
